import * as React from 'react'
import type { MenuItem } from 'instantsearch.js/es/connectors/menu/connectMenu'
import type { SearchForFacetValuesResponse } from '@algolia/client-search'
import { algoliaTemplatesIndex } from 'algolia/algolia-templates'
import { defaultSearchClient } from 'algolia/algolia'
import { useCategories } from 'algolia/algolia.components'

export function transformItems(items: MenuItem[]) {
  // oxlint-disable-next-line unicorn/no-array-sort
  return items.sort((a, b) => a.value.localeCompare(b.value))
}

function filterHits({ facetHits }: SearchForFacetValuesResponse) {
  const filteredHits = facetHits.filter(hit => !hit.value.includes('>'))
  return filteredHits.map(facet => ({
    label: facet.value,
    value: facet.value,
    isRefined: false,
    count: facet.count || 0,
  }))
}

export function searchForFacets(
  params: { facetName?: string; facetQuery?: string; query?: string; filters?: string } = {},
) {
  const facetName = params.facetName ?? 'category'
  const facetQuery = params.facetQuery ?? ''
  const searchParams = new URLSearchParams()
  if (params.query) {
    searchParams.set('query', params.query)
  }
  if (params.filters) {
    searchParams.set('filters', params.filters)
  }
  const paramsStr = searchParams.toString()

  return defaultSearchClient
    .searchForFacetValues({
      indexName: algoliaTemplatesIndex,
      facetName,
      searchForFacetValuesRequest: {
        facetQuery,
        maxFacetHits: 100,
        ...(paramsStr ? { params: paramsStr } : {}),
      },
    })
    .then(filterHits)
}

interface useSelectedCategoryProps {
  isSubcategory?: boolean
}
export function useSelectedCategory({ isSubcategory = false }: useSelectedCategoryProps = {}) {
  const [selectedCategory, setSelectedCategory] = React.useState<MenuItem>()

  const { category, subcategory } = useCategories()
  const selectedCategoryName = isSubcategory ? subcategory : category

  React.useEffect(() => {
    if (!selectedCategoryName) {
      setSelectedCategory(undefined)
      return
    }
    searchForFacets({
      facetName: isSubcategory ? 'subcategory' : 'category',
      facetQuery: selectedCategoryName,
    }).then(transformedHits => {
      setSelectedCategory(transformedHits[0])
    })
  }, [isSubcategory, selectedCategoryName])

  return selectedCategory
}
